import { render, staticRenderFns } from "./AdminDiagnostics.vue?vue&type=template&id=ba582fae&scoped=true"
import script from "./AdminDiagnostics.vue?vue&type=script&lang=js"
export * from "./AdminDiagnostics.vue?vue&type=script&lang=js"
import style0 from "./AdminDiagnostics.vue?vue&type=style&index=0&id=ba582fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba582fae",
  null
  
)

export default component.exports